import { render } from "./deductGoods.vue?vue&type=template&id=0ab16f0c&scoped=true"
import script from "./deductGoods.vue?vue&type=script&lang=js"
export * from "./deductGoods.vue?vue&type=script&lang=js"

import "./deductGoods.vue?vue&type=style&index=0&id=0ab16f0c&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab16f0c"]])

export default __exports__